// extracted by mini-css-extract-plugin
export var button = "_16-0";
export var buttonContent = "_16-e";
export var buttonGroup = "_16-c";
export var dontRestrainIconWidth = "_16-a";
export var dropdownButton = "_16-b";
export var iconContainer = "_16-9";
export var lg = "_16-4";
export var md = "_16-3";
export var pending = "_16-f";
export var sm = "_16-2";
export var spinner = "_16-d";
export var squared = "_16-8";
export var wrapText = "_16-g";
export var xl = "_16-5";
export var xs = "_16-1";
export var xxl = "_16-6";
export var xxxl = "_16-7";